<template>
  <div>
    <div>
      <router-link to="/">Home </router-link>
      <label class="labelBar"> / </label>
      <router-link :to="{ path: '/equipamento', query: $route.query }"
        >Cadastro/Equipamento/Equipamentos</router-link
      >
      <label class="labelBar"> / </label>
      <label> Editar</label>
    </div>
    <tab-navegacao-equipamento />
    <v-container fluid>
      <!-- Principal -->
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-radio-group v-model="tipo" row>
          <v-radio label="Proprio" value="1"></v-radio>
          <v-radio label="Alugado" value="2"></v-radio>
        </v-radio-group>
        <v-row>
          <v-col cols="12" sm="10">
            <v-row align="center">
              <v-col cols="12" sm="6">
                <v-select
                  v-model="familiaSelected"
                  :items="filteredFamilias"
                  label="Grupo *"
                  item-text="descricao"
                  item-value="id"
                  persistent-hint
                  return-object
                  :readonly="readOnly"
                  :rules="[(v) => !!v || 'O grupo é obrigatório']"
                  required
                >
                </v-select>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field
                  label="Chassi"
                  v-model="chassi"
                  :counter="200"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="6">
                <v-text-field
                  label="Placa *"
                  v-model="placa"
                  v-uppercase
                  :counter="8"
                  :rules="[(v) => !!v || 'A Placa é obrigatória']"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field
                  label="Ano *"
                  v-model="ano"
                  :counter="4"
                  v-mask="['####']"
                  :rules="[
                    (v) => !!v || 'O Ano é obrigatório',
                    (v) =>
                      (v && v.length == 4) || 'O ano deve ter 4 caracteres',
                  ]"
                  required
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="6">
                <v-text-field
                  label="Prefixo *"
                  v-model="prefixo"
                  v-uppercase
                  :rules="[(v) => !!v || 'O Prefixo é obrigatório']"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field
                  label="Apelido *"
                  v-model="apelido"
                  v-uppercase
                  :rules="[(v) => !!v || 'O Apelido é obrigatório']"
                  required
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row align="center">
              <v-col cols="12" sm="6">
                <v-autocomplete
                  v-model="grupoSelected"
                  :items="filteredGrupo"
                  label="Capacidade *"
                  item-text="descricao"
                  item-value="id"
                  persistent-hint
                  return-object
                  :readonly="readOnly"
                  :rules="[(v) => !!v || 'A capacidade é obrigatória']"
                  required
                >
                </v-autocomplete>
              </v-col>
              <v-col cols="12" sm="6">
                <v-autocomplete
                  v-model="marcaSelected"
                  :items="filteredMarcaEquipamentos"
                  label="Marca *"
                  item-text="descricao"
                  item-value="id"
                  persistent-hint
                  return-object
                  :readonly="readOnly"
                  :rules="[(v) => !!v || 'A Marca é obrigatória']"
                  @change="validarModeloSelecionado"
                  required
                >
                </v-autocomplete>
              </v-col>
            </v-row>
            <v-row align="center">
              <v-col cols="12" sm="6">
                <v-autocomplete
                  v-model="modeloSelected"
                  :items="filteredModelos"
                  label="Modelo *"
                  item-text="descricao"
                  item-value="id"
                  persistent-hint
                  return-object
                  :readonly="readOnly"
                  :disabled="!marcaSelected || readOnly"
                  :rules="[(v) => !!v || 'O Modelo é obrigatório']"
                  required
                >
                </v-autocomplete>
              </v-col>
              <v-col cols="12" sm="6">
                <v-select
                  v-model="proprietarioSelected"
                  :items="filteredProprietario"
                  label="Prorietário *"
                  item-text="nome"
                  item-value="id"
                  persistent-hint
                  return-object
                  :readonly="readOnly"
                  :rules="[(v) => !!v || 'O Proprietario é obrigatório']"
                  required
                >
                </v-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="6">
                <v-text-field
                  label="Centro de Custo *"
                  v-model="centroCusto"
                  :rules="[(v) => !!v || 'O Centro de Custo é obrigatório']"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field
                  label="Seguradora"
                  v-model="seguradora"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row align="center">
              <v-col cols="12" sm="6">
                <v-select
                  v-model="unidadeAdmSelected"
                  :items="filteredUnidAdm"
                  label="Local *"
                  item-text="descricao"
                  item-value="id"
                  persistent-hint
                  return-object
                  :readonly="readOnly"
                  :rules="[(v) => !!v || 'O Local é obrigatório']"
                  required
                >
                </v-select>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" sm="2">
            <v-row>
              <v-file-input
                :rules="[
                  (value) =>
                    !value ||
                    value.size < 2000000 ||
                    'Avatar size should be less than 2 MB!',
                ]"
                accept="image/png, image/jpeg, image/bmp"
                prepend-icon="mdi-camera"
                @change="Preview_imagem(imagem)"
                v-model="imagem"
                hide-input
              ></v-file-input>
            </v-row>
            <v-row>
              <v-img :src="urlImagem"></v-img
              ><v-chip
                v-if="urlImagem != null"
                class="ma-2"
                close
                @click:close="removeImagem"
              >
                Remover
              </v-chip>
            </v-row>
          </v-col>
        </v-row>
      </v-form>
      <!-- Financeiro -->
      <v-card class="mx-auto">
        <v-card-actions>
          <v-btn color="orange lighten-2" @click="expandFn = !expandFn" text>
            Financeiro
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn icon @click="expandFn = !expandFn">
            <v-icon>{{
              expandFn ? "mdi-chevron-up" : "mdi-chevron-down"
            }}</v-icon>
          </v-btn>
        </v-card-actions>
        <v-expand-transition>
          <div v-show="expandFn">
            <v-divider></v-divider>
            <v-card-text>
              <v-form ref="formFn" v-model="valid" lazy-validation>
                <v-row align="center">
                  <v-col cols="12" sm="6">
                    <vuetify-money
                      v-model="valorCompra"
                      label="Valor Compra"
                      v-bind:options="options"
                    />
                  </v-col>
                  <v-col cols="12" sm="5">
                    <v-text-field
                      label="Nota fiscal compra"
                      v-model="nfCompra"
                      v-uppercase
                      :counter="200"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="1">
                    <v-file-input
                      nfAnexoCompra
                      @change="Preview_nc_compra(nfAnexoCompra)"
                      v-model="nfAnexoCompra"
                      hide-input
                    ></v-file-input>
                  </v-col>
                </v-row>
                <v-row align="center">
                  <v-col cols="12" sm="6">
                    <vuetify-money
                      v-model="valorVenda"
                      label="Valor venda"
                      v-bind:options="options"
                    />
                  </v-col>
                  <v-col cols="12" sm="5">
                    <v-text-field
                      label="Nota fiscal venda"
                      v-model="nfVenda"
                      v-uppercase
                      :counter="200"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="1">
                    <v-file-input
                      nfAnexoVenda
                      @change="Preview_nc_venda"
                      v-model="nfAnexoVenda"
                      hide-input
                    ></v-file-input>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="6">
                    <v-menu
                      v-model="data1"
                      :close-on-content-click="false"
                      max-width="290"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          :value="computedDate1"
                          clearable
                          label="Data da compra"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          @click:clear="dataCompra = null"
                          required
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="dataCompra"
                        @change="data1 = false"
                      ></v-date-picker>
                    </v-menu> </v-col
                  ><v-col cols="12" sm="6">
                    <v-menu
                      v-model="data2"
                      :close-on-content-click="false"
                      max-width="290"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          :value="computedDate2"
                          clearable
                          label="Data venda"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          @click:clear="dataVenda = null"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="dataVenda"
                        @change="data2 = false"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                </v-row>
                <v-row align="center">
                  <v-col cols="6" sm="4">
                    <v-img :src="urlNfCompra"></v-img
                    ><v-chip
                      v-if="nfAnexoCompra != null || anexoNfCompra.length > 0"
                      class="ma-2"
                      close
                      @click:close="removeAnexoCompra"
                    >
                      NF Compra:
                      {{
                        nfAnexoCompra != null
                          ? nfAnexoCompra.name
                          : anexoNfCompra
                      }}
                    </v-chip>
                    <v-btn
                      @click="baixarAnexoCompra"
                      v-if="anexoNfCompra.length > 0"
                      text
                      color="primary"
                      >baixar
                    </v-btn>
                  </v-col>
                  <v-col cols="6" sm="4">
                    <v-img :src="urlNfVenda"></v-img
                    ><v-chip
                      v-if="nfAnexoVenda != null || anexoNfVenda.length > 0"
                      class="ma-2"
                      close
                      @click:close="removeAnexoVenda"
                    >
                      NF Venda:
                      {{
                        this.nfAnexoVenda != null
                          ? nfAnexoVenda.name
                          : anexoNfVenda
                      }}
                    </v-chip>
                    <v-btn
                      @click="baixarAnexoVenda"
                      v-if="anexoNfVenda.length > 0"
                      text
                      color="primary"
                      >baixar
                    </v-btn>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>
          </div>
        </v-expand-transition>
      </v-card>
      <!-- Implemento -->
      <v-card class="mx-auto">
        <v-card-actions>
          <v-btn color="orange lighten-2" @click="expandImp = !expandImp" text>
            Implemento
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn icon @click="expandImp = !expandImp">
            <v-icon>{{
              expandImp ? "mdi-chevron-up" : "mdi-chevron-down"
            }}</v-icon>
          </v-btn>
        </v-card-actions>
        <v-expand-transition>
          <div v-show="expandImp">
            <v-divider></v-divider>
            <v-card-text>
              <v-form ref="formImp" v-model="valid2" lazy-validation>
                <v-row align="center">
                  <v-col cols="12" sm="6">
                    <v-select
                      v-model="implementoSelected"
                      :items="filteredImplemento"
                      label="Implemento *"
                      item-text="nome"
                      item-value="id"
                      persistent-hint
                      return-object
                      :rules="[(v) => !!v || 'O Implemento é obrigatório']"
                      required
                    >
                    </v-select>
                  </v-col>
                </v-row>
              </v-form>
              <v-row align="center">
                <v-col class="text-right">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        color="info"
                        fab
                        small
                        v-bind="attrs"
                        v-on="on"
                        @click="addImplemento()"
                        class="white--text"
                      >
                        <v-icon> mdi-plus </v-icon>
                      </v-btn>
                    </template>
                    <span>Adicionar</span>
                  </v-tooltip>
                </v-col>
              </v-row>
              <v-data-table
                :headers="headersImp"
                hide-default-footer
                :items-per-page="-1"
                :items="epImplementos"
              >
                <template v-slot:item.actions="{ item }">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        class="mr-2"
                        color="error"
                        @click="removeImplemento(item.id)"
                        v-bind="attrs"
                        v-on="on"
                      >
                        mdi-close-thick
                      </v-icon>
                    </template>
                    <span>Remover</span>
                  </v-tooltip>
                </template>
              </v-data-table>
            </v-card-text>
          </div>
        </v-expand-transition>
      </v-card>
      <!-- Acessorio -->
      <v-card class="mx-auto">
        <v-card-actions>
          <v-btn color="orange lighten-2" @click="expandAc = !expandAc" text>
            Acessório
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn icon @click="expandAc = !expandAc">
            <v-icon>{{
              expandAc ? "mdi-chevron-up" : "mdi-chevron-down"
            }}</v-icon>
          </v-btn>
        </v-card-actions>
        <v-expand-transition>
          <div v-show="expandAc">
            <v-divider></v-divider>
            <v-card-text>
              <v-form ref="formAc" v-model="valid3" lazy-validation>
                <v-row align="center">
                  <v-col cols="12" sm="6">
                    <v-select
                      v-model="acessorioSelected"
                      :items="filteredAcessorio"
                      label="Acessório *"
                      item-text="descricao"
                      item-value="id"
                      persistent-hint
                      return-object
                      :rules="[(v) => !!v || 'O Acessório é obrigatório']"
                      required
                    >
                    </v-select>
                  </v-col>
                </v-row>
              </v-form>
              <v-row align="center">
                <v-col class="text-right">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        color="info"
                        fab
                        small
                        v-bind="attrs"
                        v-on="on"
                        @click="addAcessorio()"
                        class="white--text"
                      >
                        <v-icon> mdi-plus </v-icon>
                      </v-btn>
                    </template>
                    <span>Adicionar Acessório</span>
                  </v-tooltip>
                </v-col>
              </v-row>
              <v-data-table
                :headers="headersAc"
                hide-default-footer
                :items-per-page="-1"
                :items="epAcessorios"
              >
                <template v-slot:item.actions="{ item }">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        class="mr-2"
                        color="error"
                        @click="removeAcessorio(item.id)"
                        v-bind="attrs"
                        v-on="on"
                      >
                        mdi-close-thick
                      </v-icon>
                    </template>
                    <span>Remover</span>
                  </v-tooltip>
                </template>
              </v-data-table>
            </v-card-text>
          </div>
        </v-expand-transition>
      </v-card>
      <!-- Tecnica -->
      <v-card class="mx-auto">
        <v-card-actions>
          <v-btn color="orange lighten-2" @click="expandTc = !expandTc" text>
            Informações Técnicas
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn icon @click="expandTc = !expandTc">
            <v-icon>{{
              expandTc ? "mdi-chevron-up" : "mdi-chevron-down"
            }}</v-icon>
          </v-btn>
        </v-card-actions>
        <v-expand-transition>
          <div v-show="expandTc">
            <v-divider></v-divider>
            <v-card-text>
              <v-form ref="formTec" v-model="valid" lazy-validation>
                <v-row align="center">
                  <v-col cols="12" sm="6">
                    <v-text-field
                      label="Descrição *"
                      v-model="descricaoTecnica"
                      v-uppercase
                      :counter="200"
                      :rules="[(v) => !!v || 'A Descrição é obrigatória']"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-text-field
                      label="Observação *"
                      v-model="observacaoTecnica"
                      v-uppercase
                      :counter="200"
                      :rules="[(v) => !!v || 'A Observação é obrigatória']"
                      required
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-form>
              <v-row align="center">
                <v-col class="text-right">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        color="info"
                        fab
                        small
                        v-bind="attrs"
                        v-on="on"
                        @click="addTecnica()"
                        class="white--text"
                      >
                        <v-icon> mdi-plus </v-icon>
                      </v-btn>
                    </template>
                    <span>Adicionar Informação Técnica</span>
                  </v-tooltip>
                </v-col>
              </v-row>
              <v-data-table
                :headers="headersTc"
                hide-default-footer
                :items-per-page="-1"
                :items="infoTecnicas"
              >
                <template v-slot:item.actions="{ item }">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        class="mr-2"
                        color="error"
                        @click="removeTecnica(item.index)"
                        v-bind="attrs"
                        v-on="on"
                      >
                        mdi-close-thick
                      </v-icon>
                    </template>
                    <span>Remover</span>
                  </v-tooltip>
                </template>
              </v-data-table>
            </v-card-text>
          </div>
        </v-expand-transition>
      </v-card>
      <!-- Anexo -->
      <v-card class="mx-auto">
        <v-card-actions>
          <v-btn color="orange lighten-2" @click="expandAnx = !expandAnx" text>
            Anexos
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn icon @click="expandAnx = !expandAnx">
            <v-icon>{{
              expandAnx ? "mdi-chevron-up" : "mdi-chevron-down"
            }}</v-icon>
          </v-btn>
        </v-card-actions>
        <v-expand-transition>
          <div v-show="expandAnx">
            <v-divider></v-divider>
            <v-card-text>
              <v-form ref="formAnx" v-model="valid" lazy-validation>
                <v-row align="center">
                  <v-col cols="12" sm="6">
                    <v-text-field
                      label="Descrição *"
                      v-model="descricaoAnexo"
                      v-uppercase
                      :counter="200"
                      :rules="[(v) => !!v || 'A Descrição é obrigatória']"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="3">
                    <v-file-input
                      v-model="fileAnexo"
                      truncate-length="30"
                      required
                    ></v-file-input>
                  </v-col>
                  <v-col cols="12" sm="1">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          color="info"
                          fab
                          small
                          v-bind="attrs"
                          v-on="on"
                          @click="addAnexo()"
                          class="white--text"
                        >
                          <v-icon> mdi-plus </v-icon>
                        </v-btn>
                      </template>
                      <span>Adicionar</span>
                    </v-tooltip>
                  </v-col>
                </v-row>
              </v-form>
              <v-data-table
                :headers="headersAnx"
                hide-default-footer
                :items-per-page="-1"
                :items="anexos"
              >
                <template v-slot:item.actions="{ item }">
                  <v-tooltip bottom v-if="item.id && item.id > 0">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        class="mr-2"
                        color="primary"
                        @click="baixarAnexo(item)"
                        v-bind="attrs"
                        v-on="on"
                      >
                        mdi-download
                      </v-icon>
                    </template>
                    <span>Baixar</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        class="mr-2"
                        color="error"
                        @click="removeAnexo(item.index)"
                        v-bind="attrs"
                        v-on="on"
                      >
                        mdi-close-thick
                      </v-icon>
                    </template>
                    <span>Remover</span>
                  </v-tooltip>
                </template>
              </v-data-table>
            </v-card-text>
          </div>
        </v-expand-transition>
      </v-card>
      <!-- final -->
      <v-row align="center">
        <v-col>
          <v-speed-dial v-model="fab" bottom right fixed>
            <template v-slot:activator>
              <v-btn color="blue darken-2" dark fab>
                <v-icon v-if="fab">mdi-close</v-icon>
                <v-icon v-else>done</v-icon>
              </v-btn>
            </template>
            <v-btn
              @click="enviar"
              color="success"
              class="mr-4"
              v-if="!readOnly"
            >
              Salvar
            </v-btn>
            <v-btn
              :to="{ path: '/equipamento', query: $route.query }"
              color="error"
              class="mr-4"
              v-if="!readOnly"
            >
              Voltar
            </v-btn>
            <v-btn :to="{ path: '/equipamento', query: $route.query }" color="success" class="mr-4" v-else>
              Voltar
            </v-btn>
          </v-speed-dial>
        </v-col>
        <v-col cols="24" sm="12">
          <v-checkbox
            v-model="equipamento.ativo"
            @click.native.stop.prevent="checkAssociacao()"
            label="Ativo"
            :readonly="readOnly"
          ></v-checkbox>
        </v-col>
      </v-row>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>

      <v-snackbar v-model="errorSnackbar" color="error" timeout="3000"
        >{{ errorMessage }}.
      </v-snackbar>
    </v-container>
  </div>
</template>

<script>
import {
  editarEquipamentoAsync,
  obterBase64NFCompraAsync,
  obterBase64NFVendaAsync,
  downloadNFCompra,
  downloadNFVenda,
  downloadAnexo,
} from "../../../services/equipamentoService";
import { mapState, mapActions } from "vuex";
import { getUserPermission } from "@/services/loginService";
import moment from "moment";

export default {
  name: "editarEquipamento",
  data: () => ({
    valid: true,
    valid2: true,
    valid3: true,
    overlay: false,
    tipo: null,
    familiaSelected: null,
    unidadeAdmSelected: null,
    chassi: null,
    placa: null,
    ano: null,
    prefixo: null,
    apelido: null,
    grupoSelected: null,
    marcaSelected: null,
    modeloSelected: null,
    proprietarioSelected: null,
    //centroCusto: null,
    seguradora: null,
    valorVenda: null,
    nfVenda: null,
    nfAnexoVenda: null,
    anexoNfVenda: null,
    valorCompra: null,
    nfCompra: null,
    nfAnexoCompra: null,
    anexoNfCompra: null,
    dataCompra: null,
    dataVenda: null,
    data1: false,
    data2: false,
    implementoSelected: null,
    acessorioSelected: null,
    descricaoTecnica: null,
    observacaoTecnica: null,
    expandFn: false,
    expandAc: false,
    expandTc: false,
    expandPm: false,
    expandAss: false,
    expandAnx: false,
    expandImp: false,
    epImplementos: [],
    epAcessorios: [],
    infoTecnicas: [],
    descricaoAnexo: null,
    fileAnexo: null,
    anexos: [],
    imagem: null,
    urlImagem: null,
    errorMessage: null,
    errorSnackbar: false,
    readOnly: false,
    fab: false,

    urlNfCompra: null,
    urlNfVenda: null,
    options: {
      locale: "pt-BR",
      prefix: "R$",
      precision: 2,
    },
    headersImp: [
      { text: "Id", value: "id", sortable: false },
      { text: "Implemento", value: "nome", sortable: false },
      { text: "Descrição", value: "descricao", sortable: false },
      { text: "", value: "actions", sortable: false },
    ],
    headersAc: [
      { text: "Id", value: "id", sortable: false },
      { text: "Acessório", value: "descricao", sortable: false },
      { text: "Observação", value: "observacao", sortable: false },
      { text: "", value: "actions", sortable: false },
    ],
    headersTc: [
      { text: "Descrição", value: "descricao", sortable: false },
      { text: "Observação", value: "observacao", sortable: false },
      { text: "", value: "actions", sortable: false },
    ],
    headersAnx: [
      { text: "Id", value: "id", sortable: false },
      { text: "Descrição", value: "descricao", sortable: false },
      { text: "Anexo", value: "nome", sortable: false },
      { text: "", value: "actions", sortable: false },
    ],

    fileImgExtension: ["jpg", "jpeg", "png"],
  }),
  computed: {
    ...mapState("equipamento", ["equipamento"]),
    ...mapState("familia", ["familias"]),
    ...mapState("marcaEquipamento", ["marcaEquipamentos"]),
    ...mapState("modelo", ["modelos"]),
    ...mapState("local", ["locais"]),
    ...mapState("grupoEquipamento", ["grupoEquipamentos"]),
    ...mapState("equipamento", ["proprietarios"]),
    ...mapState("equipamento", ["implementos"]),
    ...mapState("equipamento", ["acessorios"]),
    filteredFamilias() {
      return this.familias.filter((f) => {
        return f.ativo === true;
      });
    },
    filteredUnidAdm() {
      return this.locais.filter((l) => {
        return (
          l.ativo === true && (l.idTipoLocais === 2 || l.idTipoLocais === 3)
        );
      });
    },
    filteredMarcaEquipamentos() {
      return this.marcaEquipamentos.filter((m) => {
        return m.ativo === true;
      });
    },
    filteredModelos() {
      const marcaId = this.getMarcaId(this.marcaSelected);
      if (!marcaId) {
        return [];
      }

      return this.modelos.filter((m) => {
        return m.ativo === true && m.idMarcaEquipamento === marcaId;
      });
    },
    filteredGrupo() {
      return this.grupoEquipamentos.filter((g) => {
        return g.ativo === true;
      });
    },
    filteredProprietario() {
      return this.proprietarios.filter((p) => {
        return p.ativo === true;
      });
    },
    filteredImplemento() {
      return this.implementos.filter((i) => {
        return i.ativo === true;
      });
    },
    filteredAcessorio() {
      return this.acessorios.filter((a) => {
        return a.ativo === true;
      });
    },
    centroCusto() {
      return (
        (this.prefixo != null ? this.prefixo + " " : "") +
        (this.apelido != null ? this.apelido : "") +
        (this.modeloSelected != null || this.ano != null ? "/" : "") +
        (this.modeloSelected != null
          ? this.modeloSelected.descricao + " "
          : "") +
        (this.ano != null ? this.ano : "")
      );
    },
    computedDate1() {
      return this.dataCompra
        ? moment(this.dataCompra).format("DD/MM/YYYY")
        : null;
    },
    computedDate2() {
      return this.dataVenda
        ? moment(this.dataVenda).format("DD/MM/YYYY")
        : null;
    },
  },
  methods: {
    ...mapActions("equipamento", ["atualizarEquipamentos", "obterEquipamento"]),
    getMarcaId(marca) {
      return marca ? marca.id : null;
    },
    modeloPertenceMarca(modelo, marca) {
      const marcaId = this.getMarcaId(marca);
      return !!modelo && !!marcaId && modelo.idMarcaEquipamento === marcaId;
    },
    validarModeloSelecionado() {
      if (!this.modeloPertenceMarca(this.modeloSelected, this.marcaSelected)) {
        this.modeloSelected = null;
      }
    },
    Preview_nc_compra(imagem) {
      this.urlNfCompra = URL.createObjectURL(imagem);
    },
    Preview_nc_venda() {
      this.urlNfVenda = URL.createObjectURL(this.nfAnexoVenda);
    },
    Preview_imagem(imagem) {
      this.urlImagem = URL.createObjectURL(imagem);
    },
    checkAssociacao: async function () {
      if (!this.equipamentos.ativo) {
        if (!this.equipamentos || this.equipamentos.length == 0) {
          this.overlay = true;
          try {
            await this.atualizarEquipamentos();
          } finally {
            this.overlay = false;
          }
        }
      }
    },
    async enviar() {
      /*if (this.epImplementos.length == 0) {
        this.$alert(
          "Os implementos não foram preenchidos",
          "Desculpe, falha na operação!",
          "error"
        );
      } else if (this.epAcessorios.length == 0) {
        this.$alert(
          "Os acessórios não foram preenchidos",
          "Desculpe, falha na operação!",
          "error"
        );
      } else if (this.infoTecnicas.length == 0) {
        this.$alert(
          "As informações técnicas não foram preenchidas",
          "Desculpe, falha na operação!",
          "error"
        );
      } else if (this.anexos.length == 0) {
        this.$alert(
          "Nenhum anexo foi adicionado",
          "Desculpe, falha na operação!",
          "error"
        );
      } else*/
      if (this.$refs.form.validate()) {
        this.overlay = true;
        try {
          const resposta = await editarEquipamentoAsync(
            this.equipamento.id,
            this.imagem,
            parseInt(this.tipo),
            this.familiaSelected.id,
            this.unidadeAdmSelected.id,
            this.chassi,
            this.placa,
            this.prefixo,
            this.ano,
            this.apelido,
            this.grupoSelected.id,
            this.marcaSelected.id,
            this.modeloSelected.id,
            this.proprietarioSelected.id,
            this.centroCusto,
            this.seguradora,
            this.valorCompra,
            this.valorVenda,
            this.dataVenda,
            this.dataCompra,
            this.nfVenda,
            this.nfCompra,
            this.nfAnexoCompra,
            this.nfAnexoVenda,
            this.nfAnexoCompra != null
              ? this.nfAnexoCompra.name
              : this.anexoNfCompra,
            this.nfAnexoVenda != null
              ? this.nfAnexoVenda.name
              : this.anexoNfVenda,
            this.epImplementos,
            this.epAcessorios,
            this.infoTecnicas,
            this.anexos,
            this.equipamento.ativo
          );

          if (resposta) {
            this.$alert(
              this.obterMensagemErroSalvar(resposta),
              "Desculpe, falha na operação!",
              "error"
            );
            return;
          }

          this.$store.dispatch("ui/showSnackbar", {
            text: "Atualizado com sucesso!",
            color: "success",
            timeout: 3000,
          });
          this.$router.push({ path: '/equipamento', query: this.$route.query });
        } catch (error) {
          this.$alert(
            this.obterMensagemErroSalvar(error),
            "Desculpe, falha na operação!",
            "error"
          );
        } finally {
          this.overlay = false;
        }
      }
    },
    obterMensagemErroSalvar(error) {
      const mensagem =
        error?.response?.data?.message ||
        error?.response?.data?.Message ||
        error?.message ||
        error?.message;

      if (!mensagem || /(InvalidOperationException|MySql|Transaction|QueryAsync|StackTrace|System\.)/i.test(mensagem)) {
        return "Não foi possível salvar o equipamento. Tente novamente.";
      }

      return mensagem;
    },
    addImplemento: function (e) {
      if (!this.$refs.formImp.validate()) {
        e.preventDefault();
      }

      this.epImplementos.index =
        this.epImplementos.length === 0
          ? 0
          : this.epImplementos[this.epImplementos.length - 1].index + 1;

      this.epImplementos.push(
        JSON.parse(JSON.stringify(this.implementoSelected))
      );
      this.implementoSelected = null;
      this.$refs.formImp.resetValidation();
    },
    removeImplemento(index) {
      this.epImplementos = this.epImplementos.filter((e) => e.id != index);
    },
    removeAnexoCompra() {
      this.nfAnexoCompra = null;
      this.urlNfCompra = null;
      this.anexoNfCompra = "";
    },
    removeAnexoVenda() {
      this.nfAnexoVenda = null;
      this.urlNfVenda = null;
      this.anexoNfVenda = "";
    },
    removeImagem() {
      this.imagem = null;
      this.urlImagem = null;
    },
    baixarAnexoCompra() {
      downloadNFCompra(
        this.equipamento.id,
        this.equipamento.anexoNfCompra.split(".").pop(),
        this.equipamento.anexoNfCompra
      );
    },
    baixarAnexoVenda() {
      downloadNFVenda(
        this.equipamento.id,
        this.equipamento.anexoNfVenda.split(".").pop(),
        this.equipamento.anexoNfVenda
      );
    },
    async baixarAnexo(item) {
      const resposta = await downloadAnexo(this.equipamento.id, item.id, item.nome);
      if (resposta && resposta.status != null && resposta.status == false
      ) {
        this.errorSnackbar = true;
        this.errorMessage = 'Este arquivo não está disponível';
      }
    },
    addAcessorio: function (e) {
      try {
        if (!this.$refs.formAc.validate()) {
          e.preventDefault();
        }
        this.epAcessorios.index =
          this.epAcessorios.length === 0
            ? 0
            : this.epAcessorios[this.epAcessorios.length - 1].index + 1;

        this.epAcessorios.push(
          JSON.parse(JSON.stringify(this.acessorioSelected))
        );
        this.acessorioSelected = null;
        this.$refs.formAc.resetValidation();
      } catch (e) {
        alert(e);
      }
    },
    removeAcessorio(index) {
      this.epAcessorios = this.epAcessorios.filter((e) => e.id != index);
    },
    addTecnica: function (e) {
      if (!this.$refs.formTec.validate()) {
        e.preventDefault();
      }

      var tecnica = new Object();

      tecnica.descricao = this.descricaoTecnica;
      tecnica.observacao = this.observacaoTecnica;

      tecnica.index =
        this.infoTecnicas.length === 0
          ? 0
          : this.infoTecnicas[this.infoTecnicas.length - 1].index + 1;

      this.infoTecnicas.push(JSON.parse(JSON.stringify(tecnica)));
      this.descricaoTecnica = null;
      this.observacaoTecnica = null;
      this.$refs.formTec.resetValidation();
    },
    removeTecnica(index) {
      this.infoTecnicas = this.infoTecnicas.filter((e) => e.index != index);
    },
    addAnexo: function (e) {
      if (!this.$refs.formAnx.validate() || this.fileAnexo == null) {
        e.preventDefault();
      }

      const anexo = {
        id: null,
        descricao: this.descricaoAnexo,
        nome: this.fileAnexo?.name ?? null,
        file: this.fileAnexo, // mantém o File!
        index: this.anexos.length
          ? this.anexos[this.anexos.length - 1].index + 1
          : 0,
      };

      this.anexos.push(anexo);

      this.descricaoAnexo = null;
      this.fileAnexo = null;
      this.$refs.formAnx.resetValidation();
    },
    removeAnexo(index) {
      this.anexos = this.anexos.filter((e) => e.index != index);
    },
    findFamilia(familiaId) {
      return this.familias.find((f) => f.id === familiaId);
    },
    findUnidadeAdm(idUnidadeAdm) {
      return this.locais.find((un) => un.id === idUnidadeAdm);
    },
    findGrupo(grupoId) {
      return this.grupoEquipamentos.find((g) => g.id === grupoId);
    },
    findMarca(marcaId) {
      return this.marcaEquipamentos.find((mr) => mr.id === marcaId);
    },
    findModelo(modeloId) {
      return this.modelos.find((md) => md.id === modeloId);
    },
    findProprietario(proprietarioId) {
      return this.proprietarios.find((p) => p.id === proprietarioId);
    },
    b64toBlob(b64Data, contentType = "", sliceSize = 512) {
      const byteCharacters = atob(b64Data);
      const byteArrays = [];

      for (
        let offset = 0;
        offset < byteCharacters.length;
        offset += sliceSize
      ) {
        const slice = byteCharacters.slice(offset, offset + sliceSize);

        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
      }

      const blob = new Blob(byteArrays, { type: contentType });
      return blob;
    },
    async renderAnxNFCompra(idEquipamento) {
      const img = await obterBase64NFCompraAsync(idEquipamento);
      if (img != null) {
        this.Preview_nc_compra(this.b64toBlob(img.base64));
      }
    },
    async renderAnxNFVenda(idEquipamento) {
      const img = await obterBase64NFVendaAsync(idEquipamento);
      if (img != null) {
        this.Preview_nc_compra(this.b64toBlob(img.base64));
      }
    },
  },
  created: async function () {
    const idEquipamento = Number(this.$route.query.id || this.equipamento?.id);
    if (idEquipamento && (!this.equipamento || this.equipamento.id !== idEquipamento || !this.equipamento.implementos)) {
      this.overlay = true;
      try {
        await this.obterEquipamento(idEquipamento);
      } finally {
        this.overlay = false;
      }
    }

    var index = 0;
    this.tipo = String(this.equipamento.tipo);
    this.descricao = this.equipamento.descricao;
    this.chassi = this.equipamento.chassi;
    this.placa = this.equipamento.placa;
    this.ano = this.equipamento.ano;
    this.prefixo = this.equipamento.prefixo;
    this.apelido = this.equipamento.apelido;
    this.familiaSelected = this.findFamilia(this.equipamento.idFamilia);
    this.unidadeAdmSelected = this.findUnidadeAdm(
      this.equipamento.idUnidadeAdm
    );
    this.grupoSelected = this.findGrupo(this.equipamento.idGrupo);
    this.marcaSelected = this.findMarca(this.equipamento.idMarca);
    this.modeloSelected = this.findModelo(this.equipamento.idModelo);
    this.proprietarioSelected = this.findProprietario(
      this.equipamento.idProprietario
    );
    this.centroCusto = this.equipamento.centroCusto;
    this.seguradora = this.equipamento.seguradora;
    this.valorCompra = this.equipamento.valorCompra;
    this.valorVenda = this.equipamento.valorVenda;
    this.dataVenda = this.equipamento.dataVenda;
    this.dataCompra = this.equipamento.dataCompra;
    this.nfVenda = this.equipamento.nfVenda;
    this.nfCompra = this.equipamento.nfCompra;
    this.epImplementos = (this.equipamento.implementos || []).slice();
    this.epAcessorios = (this.equipamento.acessorios || []).slice();
    this.infoTecnicas = (this.equipamento.informacoesTecnicas || []).slice();
    this.anexoNfCompra = this.equipamento.anexoNfCompra
      ? this.equipamento.anexoNfCompra
      : "";
    this.anexoNfVenda = this.equipamento.anexoNfVenda
      ? this.equipamento.anexoNfVenda
      : "";
    this.anexos = (this.equipamento.anexos || []).slice();
    this.epImplementos.forEach((e) => (e.index = index++));
    index = 0;
    this.epAcessorios.forEach((e) => (e.index = index++));
    index = 0;
    this.infoTecnicas.forEach((e) => (e.index = index++));
    this.anexos.forEach((e) => (e.index = index++));

    if (
      this.equipamento.anexoNfCompra &&
      this.fileImgExtension.includes(
        this.equipamento.anexoNfCompra.split(".").pop()
      )
    ) {
      this.renderAnxNFCompra(this.equipamento.id);
    }
    if (
      this.equipamento.anexoNfVenda &&
      this.fileImgExtension.includes(
        this.equipamento.anexoNfVenda.split(".").pop()
      )
    ) {
      this.renderAnxNFVenda(this.equipamento.id);
    }
    if (this.equipamento.foto != null && this.equipamento.foto.length > 0) {
      this.Preview_imagem(this.b64toBlob(this.equipamento.foto));
    }
  },
  mounted() {
    const meta = this.$route.meta || {};
    const codModulo = meta.codModulo || 3;
    this.readOnly = meta.readonly === 1 || !getUserPermission(codModulo);
  },
  watch: {
    marcaSelected(newMarca, oldMarca) {
      if (this.getMarcaId(newMarca) !== this.getMarcaId(oldMarca)) {
        this.validarModeloSelecionado();
      }
    },
  },
  components: {
    TabNavegacaoEquipamento: () => import("../../Tabs/TabCadastroEquipamento"),
  },
};
</script>

